import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Dialog, DialogContent, FormControl } from "@mui/material";
import useStyles from "./attachment-dialog.style";
import { useOcIsMobile } from "oc/hooks/use-is-mobile";
import { OcShowRequestDialogHeader } from "oc/components/show-request-dialog-header/show-request-dialog-header";

interface MyHrAttachmentDialogProps {
  showDialog: boolean;
  handleCancel: () => void;
  fileData: { slug?: string; filename?: string };
  pdfSize?: boolean;
}

export const MyHrAttachmentDialog: React.FC<MyHrAttachmentDialogProps> = ({
  showDialog,
  handleCancel,
  fileData,
  pdfSize,
}) => {
  const isMobile = useOcIsMobile();
  const classes = useStyles({ isMobile });
  const { t } = useTranslation();

  const fileSrc = fileData?.slug || fileData?.filename;

  return (
    <Dialog
      aria-labelledby="dialog-title"
      open={showDialog}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          return false;
        }
      }}
      disableEscapeKeyDown
      scroll="body"
      maxWidth={pdfSize ? "lg" : "sm"}
    >
      <DialogContent className={classes.content}>
        <Box height="16px" />
        <OcShowRequestDialogHeader
          label={""}
          close={handleCancel}
          isMobile={isMobile}
        />

        <FormControl variant="outlined" className={classes.formControl}>
          {pdfSize && (
            <iframe
              src={fileSrc}
              title="PDF visualization"
              width="100%"
              height="600px"
            />
          )}
          {!pdfSize && <img src={fileSrc} alt="Attachment" />}
          <Box height="16px" />
          <Button
            variant="text"
            color="secondary"
            id="dialog-cancel-button"
            fullWidth
            onClick={handleCancel}
            style={{ pointerEvents: "auto" }}
          >
            {t("MY_HR_LOCKUP")}
          </Button>
          <Box height="16px" />
        </FormControl>
      </DialogContent>
    </Dialog>
  );
};

export default MyHrAttachmentDialog;
